import { Alert, Snackbar } from '@mui/material';
import React, { createContext, useState } from 'react'
import ConfirmModal, { IConfirmModalProps } from '../components/Modals/ConfirmModal';
import Loader from '../components/custom/Loader';

export type TNotificationType = 'info' | 'success' | 'error'
interface INotification {
  id: string,
  message: string,
  type: TNotificationType
}

type TConfirmModal = Omit<IConfirmModalProps, 'onClose'>
type TConfirmParams = Omit<IConfirmModalProps, 'onClose' | 'open'>

export interface INotificationContext {
  notify: (message: string, type?: TNotificationType) => any,
  confirm: (params: TConfirmParams) => any,
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
  loading: boolean;
}

const notificationInitialState: INotification = {
  id: '',
  message: '',
  type: 'success',
}

const confirmInitialState: TConfirmModal = {
  handleConfirm: () => { },
  open: false,
  text: '',
  title: ''
}

export const NotificationContext = createContext<INotificationContext>({} as INotificationContext)


const NotificationProvider = (props: any) => {

  const [notification, setNotification] = useState<INotification>(notificationInitialState)
  const [confirmModal, setConfirmModal] = useState<TConfirmModal>(confirmInitialState)
  const [loading, setLoading] = useState<boolean>(false);

  const notify = (message: string, type?: TNotificationType) => {
    const id = Math.random().toString(36).substr(2, 9);
    type = type || 'success'
    const notification = { message, type, id }
    setNotification(notification)
  }

  const removeNotification = () => {
    setNotification(notificationInitialState)
  }

  const confirm = (params: TConfirmParams) => {
    setConfirmModal({ ...params, open: true })
  }

  const closeConfirmModal = () => {
    setConfirmModal(confirmInitialState)
  }

  return (
    <NotificationContext.Provider
      value={{
        notify, confirm, loading, setLoading
      }}>
      <ConfirmModal {...confirmModal} onClose={closeConfirmModal} />
      {loading ? <Loader /> : <></>}
      <Snackbar style={{ zIndex: 999999 }} open={Boolean(notification.id)} autoHideDuration={6000} onClose={removeNotification}>
        <Alert
          onClose={removeNotification}
          severity={notification.type}
          sx={{ width: '100%' }}>
          {notification.message}
        </Alert>
      </Snackbar>
      {props.children}
    </NotificationContext.Provider>
  )
}

export default NotificationProvider
